module.exports = __webpack_public_path__ + "img/tennis.282e4b01.svg";